import React from 'react'
import { Link } from 'gatsby'
import {
  Layout,
  Header,
  Showcase,
  SectionTitle,
  Intro,
} from '../../../../components'
import data from './data.json'
import './style.scss'

export default props => {
  const code = {
    standard: `<div class="p-list-action l-margin-bottom--xxlarge">
    <h4 class="p-list-action__title">Standard List Actions</h4>
    <button class="p-list-action__item">
      <i class="p-list-action__item-icon icon icon--card" role="img"></i>
      <span class="p-list-action__item-content">
        <span class="p-list-action__item-title--cta">
          Personal Checking
        </span>
        <span class="p-list-action__item-subtitle">
          Account ending in: 5551
        </span>
      </span>
      <span class="p-list-action__item-actions">
        <i class="icon icon--arrow-without-tail-right p-list-action__icon--animated p-list-action__icon--slide"
          role="img"></i>
      </span>
    </button>
    <button class="p-list-action__item">
      <i class="p-list-action__item-icon icon icon--card"
        role="img" ></i>
      <span class="p-list-action__item-content">
        <span class="p-list-action__item-title--cta">
          Joint Checking
        </span>
        <span class="p-list-action__item-subtitle">
          Account ending in: 5552
        </span>
      </span>
      <span class="p-list-action__item-actions">
        <i class="icon icon--arrow-without-tail-right p-list-action__icon--animated p-list-action__icon--slide"
          role="img"></i>
      </span>
    </button>
    <button class="p-list-action__item">
      <i class="p-list-action__item-icon icon icon--card"
        role="img"></i>
      <span class="p-list-action__item-content">
        <span class="p-list-action__item-title--cta">
          Credit Acccount
        </span>
        <span class="p-list-action__item-subtitle">
          Account ending in: 5553
        </span>
      </span>
      <span class="p-list-action__item-actions">
        <i class="icon icon--arrow-without-tail-right p-list-action__icon--animated p-list-action__icon--slide"
          role="img"></i>
      </span>
    </button>
  </div>`,
    singleAction: `<div class="p-list-action l-margin-bottom--xxlarge">
    <h4 class="p-list-action__title">Single Action List Items</h4>
    <div class="p-list-action__item">
      <i class="p-list-action__item-icon icon icon--card"
        role="img"></i>
      <span class="p-list-action__item-content">
        <span class="p-list-action__item-title">Personal Checking</span>
        <span class="p-list-action__item-subtitle">
          Account ending in: 5551
        </span>
      </span>
      <span class="p-list-action__item-actions">
        <button class="c-button" role="button">
          Deactivate Card
        </button>
      </span>
    </div>
    <div class="p-list-action__item">
      <i class="p-list-action__item-icon icon icon--card"
        role="img"></i>
      <span class="p-list-action__item-content">
        <span class="p-list-action__item-title">Joint Checking</span>
        <span class="p-list-action__item-subtitle">
          Account ending in: 5552
        </span>
      </span>
      <span class="p-list-action__item-actions">
        <button class="c-button--primary" role="button">
          Activate Card
        </button>
      </span>
    </div>
    <div class="p-list-action__item">
      <i class="p-list-action__item-icon icon icon--card"
        role="img"></i>
      <span class="p-list-action__item-content">
        <span class="p-list-action__item-title">Credit Account</span>
        <span class="p-list-action__item-subtitle">
          Account ending in: 5553
        </span>
      </span>
      <span class="p-list-action__item-actions">
        <button class="c-button" role="button">
          Deactivate Card
        </button>
      </span>
    </div>
  </div>`,
    multiAction: `<div class="p-list-action l-margin-bottom--xxlarge">
    <h4 class="p-list-action__title">Multiple Action List Items</h4>
    <div class="p-list-action__item">
      <i class="p-list-action__item-icon icon icon--card"
        role="img"></i>
      <span class="p-list-action__item-content">
        <span class="p-list-action__item-title">Personal Checking</span>
        <span class="p-list-action__item-subtitle">
          Account ending in: 5551
        </span>
      </span>
      <span class="p-list-action__item-actions">
        <button
          class="p-list-action__icon-action p-list-action__icon--animated p-list-action__icon--pop icon icon--cog"
          role="button"
          alt="Settings"
        >
          <span class="p-list-action__icon-action-label">Settings</span>
        </button>
        <button
          class="p-list-action__icon-action p-list-action__icon--animated p-list-action__icon--pop icon icon--pencil"
          role="button"
          alt="Edit"
        >
          <span class="p-list-action__icon-action-label">Edit</span>
        </button>
        <button
          class="p-list-action__icon-action p-list-action__icon--animated p-list-action__icon--pop icon icon--trash-can"
          role="button"
          alt="Delete"
        >
          <span class="p-list-action__icon-action-label">Delete</span>
        </button>
      </span>
    </div>
    <div class="p-list-action__item">
      <i class="p-list-action__item-icon icon icon--card"
        role="img"></i>
      <span class="p-list-action__item-content">
        <span class="p-list-action__item-title">Joint Checking</span>
        <span class="p-list-action__item-subtitle">
          Account ending in: 5552
        </span>
      </span>
      <span class="p-list-action__item-actions">
        <button
          class="p-list-action__icon-action icon icon--cog p-list-action__icon--animated  p-list-action__icon--pop"
          role="button"
          alt="Settings"
        >
          <span class="p-list-action__icon-action-label">Settings</span>
        </button>
        <button
          class="p-list-action__icon-action icon icon--pencil p-list-action__icon--animated  p-list-action__icon--pop"
          role="button"
          alt="Edit"
        >
          <span class="p-list-action__icon-action-label">Edit</span>
        </button>
        <button
          class="p-list-action__icon-action icon icon--trash-can p-list-action__icon--animated  p-list-action__icon--pop"
          role="button"
          alt="Delete"
        >
          <span class="p-list-action__icon-action-label">Delete</span>
        </button>
      </span>
    </div>
    <div class="p-list-action__item">
      <i class="p-list-action__item-icon icon icon--card"
        role="img"></i>
      <span class="p-list-action__item-content">
        <span class="p-list-action__item-title">Credit Acccount</span>
        <span class="p-list-action__item-subtitle">
          Account ending in: 5553
        </span>
      </span>
      <span class="p-list-action__item-actions">
        <button
          class="p-list-action__icon-action icon icon--cog p-list-action__icon--animated  p-list-action__icon--pop"
          role="button"
          alt="Settings"
        >
          <span class="p-list-action__icon-action-label">Settings</span>
        </button>
        <button
          class="p-list-action__icon-action icon icon--pencil p-list-action__icon--animated  p-list-action__icon--pop"
          role="button"
          alt="Edit"
        >
          <span class="p-list-action__icon-action-label">Edit</span>
        </button>
        <button
          class="p-list-action__icon-action icon icon--trash-can p-list-action__icon--animated  p-list-action__icon--pop"
          role="button"
          alt="Delete"
        >
          <span class="p-list-action__icon-action-label">Delete</span>
        </button>
      </span>
    </div>
  </div>`,
  }

  return (
    <>
      <Header
        site={data.site}
        slug={data.slug + '/develop/'}
        title={data.title}
        state="develop"
        exclusive={true}
      />
      <Layout
        category="Overview"
        site={data.site}
        slug={data.slug + '/develop/'}
        state="develop"
        title={data.title}
      >
        <Intro>
          <p>
            The list actions pattern presents the user with a list of items that
            each have one or more associated actions. All actions are applied to
            the item itself, not the list overall. The optional icon and
            subtitle can add further clarity if needed.
          </p>
        </Intro>
        <SectionTitle>Variants</SectionTitle>

        <Showcase
          site={data.site}
          title="Standard"
          text={
            <p>
              Standard list action items are individual buttons that will
              navigate the user to a new page. The icon and subtitle are
              optional. Manipulate the animation by adding or removing the{' '}
              <span class="inline__code">p-list-action__icon--animated</span>{' '}
              and <span class="inline__code">p-list-action__icon--slide</span>{' '}
              classes.
            </p>
          }
          code={code.standard}
        >
          <div class="p-list-action l-margin-bottom--xxlarge">
            <h4 class="p-list-action__title">Standard List Actions</h4>
            <button class="p-list-action__item">
              <i class="p-list-action__item-icon icon icon--card" role="img" />
              <span class="p-list-action__item-content">
                <span class="p-list-action__item-title--cta">
                  Personal Checking
                </span>
                <span class="p-list-action__item-subtitle">
                  Account ending in: 5551
                </span>
              </span>
              <span class="p-list-action__item-actions">
                <i
                  class="icon icon--arrow-without-tail-right p-list-action__icon--animated p-list-action__icon--slide"
                  role="img"
                ></i>
              </span>
            </button>
            <button class="p-list-action__item">
              <i
                class="p-list-action__item-icon icon icon--card"
                role="img"
              ></i>
              <span class="p-list-action__item-content">
                <span class="p-list-action__item-title--cta">
                  Joint Checking
                </span>
                <span class="p-list-action__item-subtitle">
                  Account ending in: 5552
                </span>
              </span>
              <span class="p-list-action__item-actions">
                <i
                  class="icon icon--arrow-without-tail-right p-list-action__icon--animated p-list-action__icon--slide"
                  role="img"
                ></i>
              </span>
            </button>
            <button class="p-list-action__item">
              <i
                class="p-list-action__item-icon icon icon--card"
                role="img"
              ></i>
              <span class="p-list-action__item-content">
                <span class="p-list-action__item-title--cta">
                  Credit Acccount
                </span>
                <span class="p-list-action__item-subtitle">
                  Account ending in: 5553
                </span>
              </span>
              <span class="p-list-action__item-actions">
                <i
                  class="icon icon--arrow-without-tail-right p-list-action__icon--animated p-list-action__icon--slide"
                  role="img"
                ></i>
              </span>
            </button>
          </div>
        </Showcase>
        <Showcase
          site={data.site}
          title="Single Action"
          text={
            <p>
              Single action list action items are contained within{' '}
              <span class="inline__code">{'<div>'}</span> tags. Except the
              optional icon, components within the list item (title, optional
              subtitle, button) are within{' '}
              <span class="inline__code">{'<span>'}</span> tags.
            </p>
          }
          code={code.singleAction}
        >
          <div class="p-list-action l-margin-bottom--xxlarge">
            <h4 class="p-list-action__title">Single Action List Items</h4>
            <div class="p-list-action__item">
              <i
                class="p-list-action__item-icon icon icon--card"
                role="img"
              ></i>
              <span class="p-list-action__item-content">
                <span class="p-list-action__item-title">Personal Checking</span>
                <span class="p-list-action__item-subtitle">
                  Account ending in: 5551
                </span>
              </span>
              <span class="p-list-action__item-actions">
                <button class="c-button">Deactivate Card</button>
              </span>
            </div>
            <div class="p-list-action__item">
              <i
                class="p-list-action__item-icon icon icon--card"
                role="img"
              ></i>
              <span class="p-list-action__item-content">
                <span class="p-list-action__item-title">Joint Checking</span>
                <span class="p-list-action__item-subtitle">
                  Account ending in: 5552
                </span>
              </span>
              <span class="p-list-action__item-actions">
                <button class="c-button--primary">Activate Card</button>
              </span>
            </div>
            <div class="p-list-action__item">
              <i
                class="p-list-action__item-icon icon icon--card"
                role="img"
              ></i>
              <span class="p-list-action__item-content">
                <span class="p-list-action__item-title">Credit Account</span>
                <span class="p-list-action__item-subtitle">
                  Account ending in: 5553
                </span>
              </span>
              <span class="p-list-action__item-actions">
                <button class="c-button">Deactivate Card</button>
              </span>
            </div>
          </div>
        </Showcase>
        <Showcase
          site={data.site}
          title="Multiple Action"
          text={
            <p>
              Multiple action list action items are contained within{' '}
              <span class="inline__code">{'<div>'}</span> tags. Except the
              optional icon, components within the list item (title, optional
              subtitle, button) are within{' '}
              <span class="inline__code">{'<span>'}</span> tags. Each icon
              action is a <span class="inline__code">{'<button>'}</span>.
              Manipulate the animation by adding or removing the{' '}
              <span class="inline__code">p-list-action__icon--animated</span>{' '}
              and <span class="inline__code">p-list-action__icon--pop</span>{' '}
              classes.
            </p>
          }
          code={code.multiAction}
        >
          <div class="p-list-action l-margin-bottom--xxlarge">
            <h4 class="p-list-action__title">Multiple Action List Items</h4>
            <div class="p-list-action__item">
              <i
                class="p-list-action__item-icon icon icon--card"
                role="img"
              ></i>
              <span class="p-list-action__item-content">
                <span class="p-list-action__item-title">Personal Checking</span>
                <span class="p-list-action__item-subtitle">
                  Account ending in: 5551
                </span>
              </span>
              <span class="p-list-action__item-actions">
                <button
                  class="p-list-action__icon-action p-list-action__icon--animated p-list-action__icon--pop icon icon--cog"
                  alt="Settings"
                >
                  <span class="p-list-action__icon-action-label">Settings</span>
                </button>
                <button
                  class="p-list-action__icon-action p-list-action__icon--animated p-list-action__icon--pop icon icon--pencil"
                  alt="Edit"
                >
                  <span class="p-list-action__icon-action-label">Edit</span>
                </button>
                <button
                  class="p-list-action__icon-action p-list-action__icon--animated p-list-action__icon--pop icon icon--trash-can"
                  alt="Delete"
                >
                  <span class="p-list-action__icon-action-label">Delete</span>
                </button>
              </span>
            </div>
            <div class="p-list-action__item">
              <i
                class="p-list-action__item-icon icon icon--card"
                role="img"
              ></i>
              <span class="p-list-action__item-content">
                <span class="p-list-action__item-title">Joint Checking</span>
                <span class="p-list-action__item-subtitle">
                  Account ending in: 5552
                </span>
              </span>
              <span class="p-list-action__item-actions">
                <button
                  class="p-list-action__icon-action icon icon--cog p-list-action__icon--animated  p-list-action__icon--pop"
                  alt="Settings"
                >
                  <span class="p-list-action__icon-action-label">Settings</span>
                </button>
                <button
                  class="p-list-action__icon-action icon icon--pencil p-list-action__icon--animated  p-list-action__icon--pop"
                  alt="Edit"
                >
                  <span class="p-list-action__icon-action-label">Edit</span>
                </button>
                <button
                  class="p-list-action__icon-action icon icon--trash-can p-list-action__icon--animated  p-list-action__icon--pop"
                  alt="Delete"
                >
                  <span class="p-list-action__icon-action-label">Delete</span>
                </button>
              </span>
            </div>
            <div class="p-list-action__item">
              <i
                class="p-list-action__item-icon icon icon--card"
                role="img"
              ></i>
              <span class="p-list-action__item-content">
                <span class="p-list-action__item-title">Credit Acccount</span>
                <span class="p-list-action__item-subtitle">
                  Account ending in: 5553
                </span>
              </span>
              <span class="p-list-action__item-actions">
                <button
                  class="p-list-action__icon-action icon icon--cog p-list-action__icon--animated  p-list-action__icon--pop"
                  alt="Settings"
                >
                  <span class="p-list-action__icon-action-label">Settings</span>
                </button>
                <button
                  class="p-list-action__icon-action icon icon--pencil p-list-action__icon--animated  p-list-action__icon--pop"
                  alt="Edit"
                >
                  <span class="p-list-action__icon-action-label">Edit</span>
                </button>
                <button
                  class="p-list-action__icon-action icon icon--trash-can p-list-action__icon--animated  p-list-action__icon--pop"
                  alt="Delete"
                >
                  <span class="p-list-action__icon-action-label">Delete</span>
                </button>
              </span>
            </div>
          </div>
        </Showcase>
        <hr />
        <SectionTitle>States</SectionTitle>
        <p>
          On hover, the arrow on standard list action items is animated to push
          to the right, indicating that the button will move the user forward.
          The buttons in the single action variant have the same hover behavior
          as the{' '}
          <Link class="link" to={'/' + data.site + '/components/button/design'}>
            button
          </Link>{' '}
          component. The icons on multiple action list items can animate to draw
          attention to the desired actions.
        </p>
      </Layout>
    </>
  )
}
